module.exports = __webpack_public_path__ + "img/luckyDraw.6bb6eaa9.png";